import { decompressSync, strFromU8 } from "fflate";
function DecompressRgObjectDto(obj) {
	return JSON.parse(strFromU8(decompressSync(obj)));
}
export { DecompressRgObjectDto };

//# sourceMappingURL=index199.js.map